export const isTruthy = <T>(value?: Maybe<false | T>): value is T => !!value
